import { NODE_TYPES_TO_EXCLUDE_FROM_TOUR } from "@zapier/canvas-constants";
import type { ExcludedTourNodeType } from "../types";

/**
 * Checks if a node can be included in tours.
 * Excludes ephemeral nodes (annotation, suggested, etc.) and non-tourable persisted nodes (text, group).
 *
 * @param node - The node to check
 * @returns true if the node can be toured, false otherwise
 */
export function isTourableNode(node: { type?: string }): boolean {
  if (!node.type) return false;

  return !NODE_TYPES_TO_EXCLUDE_FROM_TOUR.includes(
    node.type as ExcludedTourNodeType,
  );
}
